import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Card } from 'react-bootstrap'
import { format } from 'date-fns'

import ChartReviewNoteForm from './ChartReviewNoteForm'

const ChartReviewNote = (props) => {
  const { note } = props

  const [editMode, toggleEditMode] = useState(false)

  const modifiedDate = note.modified_date ? new Date(note.modified_date) : null

  const handleSaveComplete = (updatedNote) => {
    props.editChartReviewNote(updatedNote)
    toggleEditMode(false)
  }

  const handleEditClick = (e) => {
    e.preventDefault()
    return toggleEditMode(!editMode)
  }

	return (
    <Card>
      <Card.Body>
        <Card.Title>
          {note.created_by ?
            `${note.created_by.first_name} ${note.created_by.last_name}`
            :
            null
          }
        </Card.Title>

        {editMode && props.readOnly !== true ?
          <ChartReviewNoteForm
            method='PATCH'
            text={note.text}
            section={note.section}
            noteUrl={note.url}
            handleSaveComplete={handleSaveComplete}
            adverseEventName={props.adverseEventName || null}
            readOnly={props.readOnly}
            saveButtonText={props.saveButtonText}
            formLabel={props.formLabel}
            formPlaceholder={props.formPlaceholder}
          />
          :
          <Card.Text>
            {note.text}
          </Card.Text>
        }

        {modifiedDate ?
          <Card.Subtitle className='subtitle'>
            Last modified on {format(modifiedDate, "MMMM d,  yyyy 'at' kk:mm:ss")}
          </Card.Subtitle>
          :
          null
        }
        

        {note.created_by.id && props.currentUser.id === note.created_by.id && props.readOnly !== true ?
          <Card.Link href="#" onClick={handleEditClick}>
            {editMode ?
              'Cancel'
              :
              'Edit'
            }
          </Card.Link>
          :
          null
        }
      </Card.Body>
    </Card>
  )
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.loginReducer.currentUser,
  }
}

export default connect(mapStateToProps)(ChartReviewNote)